(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-section-ugc-carousel';
  var CARD_SELECTOR = '.oddit-section-ugc-carousel__card';
  var CLONE_ATTR = 'data-ugc-clone';
  var sectionState = new Map();
  var sectionCounter = 0;

  // Strip interaction state + interactivity from a cloned card so it renders
  // immediately (oddit-reveal would otherwise leave it at opacity:0) and never
  // steals focus.
  function sanitizeClone(el) {
    el.setAttribute('aria-hidden', 'true');
    el.setAttribute(CLONE_ATTR, 'true');
    var nodes = [el].concat(Array.prototype.slice.call(el.querySelectorAll('*')));
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.classList) {
        var tokens = Array.prototype.slice.call(n.classList);
        for (var j = 0; j < tokens.length; j++) {
          var c = tokens[j];
          if (c.indexOf('oddit-reveal') === 0 || c.indexOf('oddit-hover') === 0) {
            n.classList.remove(c);
          }
        }
      }
      if (n.style) {
        n.style.opacity = '';
        n.style.transform = '';
        n.style.transition = '';
      }
      if (n.removeAttribute) {
        n.removeAttribute('data-oddit-stagger');
      }
      if (n.matches && n.matches('a, button, input, select, textarea, [tabindex]')) {
        n.setAttribute('tabindex', '-1');
      }
    }
  }

  function initSection(section) {
    if (!section || section.dataset.odditUgcInit === 'true') return;
    section.dataset.odditUgcInit = 'true';

    var sectionKey = section.id || ('oddit-ugc-' + (++sectionCounter));
    if (!section.id) section.id = sectionKey;

    var track = section.querySelector('.oddit-section-ugc-carousel__track');
    if (!track) return;

    var originals = Array.prototype.slice.call(
      track.querySelectorAll(CARD_SELECTOR + ':not([' + CLONE_ATTR + '])')
    );
    var N = originals.length;
    if (N === 0) return;

    var dots = section.querySelectorAll('.oddit-section-ugc-carousel__dot');
    var D = dots.length;

    var loop = N > 1;

    var state = {
      currentIndex: 0,
      currentDomIndex: 0,
      realStart: 0,
      autoplay: null,
      programmaticScroll: false,
      userControl: false,
      settleTimer: null,
      cleanup: []
    };

    // ---- Clone the full set on both sides for seamless infinite looping ----
    // Layout becomes: [clones 0..N-1][originals 0..N-1][clones 0..N-1].
    // Real slides live at DOM indices [N, 2N); a clone immediately left of the
    // first real slide is the last slide, and vice versa — so the wrap is
    // visually continuous before we silently reset scrollLeft.
    if (loop) {
      var beforeFrag = document.createDocumentFragment();
      var afterFrag = document.createDocumentFragment();
      for (var c = 0; c < N; c++) {
        var before = originals[c].cloneNode(true);
        sanitizeClone(before);
        beforeFrag.appendChild(before);
        var after = originals[c].cloneNode(true);
        sanitizeClone(after);
        afterFrag.appendChild(after);
      }
      track.insertBefore(beforeFrag, originals[0]);
      track.appendChild(afterFrag);
      state.realStart = N;
    }

    var allSlides = track.querySelectorAll(CARD_SELECTOR);

    function getSlideOffset(domIndex) {
      var slide = allSlides[domIndex];
      if (!slide) return 0;
      // Center the slide within the viewport (symmetric bleed on both sides).
      return slide.offsetLeft + slide.offsetWidth / 2 - track.clientWidth / 2;
    }

    function toLogical(domIndex) {
      return ((domIndex - state.realStart) % N + N) % N;
    }

    // Map a logical slide (0..N-1) onto the available dots (0..D-1).
    function dotForLogical(logical) {
      if (D <= 1 || N <= 1) return 0;
      if (N <= D) return Math.min(logical, D - 1);
      return Math.round((logical / (N - 1)) * (D - 1));
    }

    // Map a clicked dot (0..D-1) back onto a logical slide (0..N-1).
    function logicalForDot(dotIndex) {
      if (N <= D) return Math.min(dotIndex, N - 1);
      if (D <= 1) return 0;
      return Math.round((dotIndex / (D - 1)) * (N - 1));
    }

    function nearestDomIndex() {
      var center = track.scrollLeft + track.clientWidth / 2;
      var closest = state.realStart;
      var closestDist = Infinity;
      for (var i = 0; i < allSlides.length; i++) {
        var slideCenter = allSlides[i].offsetLeft + allSlides[i].offsetWidth / 2;
        var dist = Math.abs(slideCenter - center);
        if (dist < closestDist) {
          closestDist = dist;
          closest = i;
        }
      }
      return closest;
    }

    function setScrollInstant(domIndex) {
      state.programmaticScroll = true;
      track.scrollTo({ left: getSlideOffset(domIndex), behavior: 'auto' });
      state.currentDomIndex = domIndex;
    }

    function smoothScrollToDom(domIndex) {
      state.programmaticScroll = true;
      state.currentDomIndex = domIndex;
      track.scrollTo({ left: getSlideOffset(domIndex), behavior: 'smooth' });
      updateDots(dotForLogical(toLogical(domIndex)));
    }

    function goToNext() { smoothScrollToDom(state.currentDomIndex + 1); }
    function goToLogical(j) { smoothScrollToDom(state.realStart + j); }
    function advanceSlide() { goToNext(); }

    function updateDots(index) {
      if (!dots || !dots.length) return;
      for (var i = 0; i < dots.length; i++) {
        if (i === index) {
          dots[i].classList.add('oddit-section-ugc-carousel__dot--active');
          dots[i].setAttribute('aria-current', 'true');
        } else {
          dots[i].classList.remove('oddit-section-ugc-carousel__dot--active');
          dots[i].removeAttribute('aria-current');
        }
      }
    }

    // If the resting position is on a clone, jump by one full set to the
    // equivalent real slide. Because clones are identical copies, the jump is
    // invisible. Returns true when it moved the scroll position.
    function normalizePosition() {
      if (!loop) { state.currentDomIndex = nearestDomIndex(); return false; }
      var dom = nearestDomIndex();
      if (dom < state.realStart) { setScrollInstant(dom + N); return true; }
      if (dom >= state.realStart + N) { setScrollInstant(dom - N); return true; }
      state.currentDomIndex = dom;
      return false;
    }

    function onScrollSettled() {
      var jumped = normalizePosition();
      state.currentIndex = toLogical(state.currentDomIndex);
      updateDots(dotForLogical(state.currentIndex));
      // When we jumped, keep the programmatic flag set so the resulting
      // scroll event isn't misread as a user scroll; the next settle clears it.
      state.programmaticScroll = jumped;
    }

    function scheduleSettle() {
      if (state.settleTimer) clearTimeout(state.settleTimer);
      state.settleTimer = setTimeout(onScrollSettled, 120);
    }

    function onScroll() {
      if (!state.programmaticScroll && state.autoplay) {
        state.autoplay.disableAutoplayPermanently();
      }
      scheduleSettle();
    }
    track.addEventListener('scroll', onScroll, { passive: true });
    state.cleanup.push(function () { track.removeEventListener('scroll', onScroll); });

    // ---- Re-align to the current slide after a resize (widths change) ----
    var resizeTimer = null;
    function onResize() {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { setScrollInstant(state.currentDomIndex); }, 150);
    }
    window.addEventListener('resize', onResize);
    state.cleanup.push(function () {
      window.removeEventListener('resize', onResize);
      if (resizeTimer) clearTimeout(resizeTimer);
    });

    (function enableDragToScroll() {
      var isDown = false;
      var didDrag = false;
      var startX = 0;
      var startScroll = 0;
      var DRAG_THRESHOLD = 5;

      function onPointerDown(e) {
        if (e.pointerType === 'touch' || (e.button !== undefined && e.button !== 0)) return;
        isDown = true;
        didDrag = false;
        startX = e.clientX;
        startScroll = track.scrollLeft;
      }
      function onPointerMove(e) {
        if (!isDown) return;
        var dx = e.clientX - startX;
        if (!didDrag && Math.abs(dx) > DRAG_THRESHOLD) {
          didDrag = true;
          track.classList.add('is-dragging');
          if (state.autoplay) state.autoplay.disableAutoplayPermanently();
          try { track.setPointerCapture(e.pointerId); } catch (err) {}
        }
        if (didDrag) {
          track.scrollLeft = startScroll - dx;
          e.preventDefault();
        }
      }
      function onPointerUp(e) {
        if (!isDown) return;
        isDown = false;
        track.classList.remove('is-dragging');
        try { track.releasePointerCapture(e.pointerId); } catch (err) {}
      }
      // Capture phase: cancel the click that immediately follows a drag.
      function onClickCapture(e) {
        if (didDrag) {
          e.preventDefault();
          e.stopPropagation();
          didDrag = false;
        }
      }
      function onDragStart(e) { e.preventDefault(); }

      track.addEventListener('pointerdown', onPointerDown);
      track.addEventListener('pointermove', onPointerMove);
      track.addEventListener('pointerup', onPointerUp);
      track.addEventListener('pointercancel', onPointerUp);
      track.addEventListener('click', onClickCapture, true);
      track.addEventListener('dragstart', onDragStart);
      state.cleanup.push(function () {
        track.removeEventListener('pointerdown', onPointerDown);
        track.removeEventListener('pointermove', onPointerMove);
        track.removeEventListener('pointerup', onPointerUp);
        track.removeEventListener('pointercancel', onPointerUp);
        track.removeEventListener('click', onClickCapture, true);
        track.removeEventListener('dragstart', onDragStart);
      });
    })();

    // ---- Autoplay (RAF-based) ----
    function initAutoplay() {
      var autoplayEnabled = section.dataset.autoplay === 'true';
      if (!autoplayEnabled || !loop) return null;

      var speedSeconds = parseInt(section.dataset.autoplaySpeed, 10) || 5;
      var intervalMs = speedSeconds * 1000;
      var rafId = null;
      var lastAdvance = performance.now();

      function disableAutoplayPermanently() {
        if (state.userControl) return;
        state.userControl = true;
        stopAutoplay();
      }

      function tick(now) {
        if (state.userControl) return;
        if (now - lastAdvance >= intervalMs) {
          advanceSlide();
          lastAdvance = now;
        }
        rafId = requestAnimationFrame(tick);
      }

      function startAutoplay() {
        if (state.userControl) return;
        if (rafId !== null) return;
        lastAdvance = performance.now();
        rafId = requestAnimationFrame(tick);
      }

      function stopAutoplay() {
        if (rafId !== null) {
          cancelAnimationFrame(rafId);
          rafId = null;
        }
      }

      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (reducedMotion.matches) {
        return {
          start: function () {},
          stop: function () {},
          destroy: function () {},
          disableAutoplayPermanently: function () {}
        };
      }

      function onVisibilityChange() {
        if (state.userControl) return;
        if (document.hidden) stopAutoplay();
        else startAutoplay();
      }
      document.addEventListener('visibilitychange', onVisibilityChange);

      function onMouseEnter() { if (!state.userControl) stopAutoplay(); }
      function onMouseLeave() { if (!state.userControl) startAutoplay(); }
      track.addEventListener('mouseenter', onMouseEnter);
      track.addEventListener('mouseleave', onMouseLeave);

      track.addEventListener('focusin', disableAutoplayPermanently);
      track.addEventListener('touchstart', disableAutoplayPermanently, { passive: true });

      function onReducedMotionChange(e) {
        if (state.userControl) return;
        if (e.matches) stopAutoplay();
        else startAutoplay();
      }
      reducedMotion.addEventListener('change', onReducedMotionChange);

      startAutoplay();

      return {
        start: startAutoplay,
        stop: stopAutoplay,
        destroy: function () {
          stopAutoplay();
          document.removeEventListener('visibilitychange', onVisibilityChange);
          track.removeEventListener('mouseenter', onMouseEnter);
          track.removeEventListener('mouseleave', onMouseLeave);
          track.removeEventListener('focusin', disableAutoplayPermanently);
          track.removeEventListener('touchstart', disableAutoplayPermanently);
          reducedMotion.removeEventListener('change', onReducedMotionChange);
        },
        disableAutoplayPermanently: disableAutoplayPermanently
      };
    }

    // ---- Wire up dots ----
    if (dots && dots.length) {
      for (var d = 0; d < dots.length; d++) {
        (function (dot) {
          dot.addEventListener('click', function () {
            var index = parseInt(dot.getAttribute('data-slide-index'), 10) || 0;
            goToLogical(logicalForDot(index));
            if (state.autoplay) state.autoplay.disableAutoplayPermanently();
          });
        }(dots[d]));
      }
    }

    // ---- Video cards: hover preview + click-to-play ----
    // Hover plays a muted 3-second loop (a teaser); clicking the overlay restarts
    // from the beginning with sound and native controls, and the video resets to
    // its poster when it finishes. Only real cards are wired — clones keep
    // preload="none" and no handlers, so they never download or play.
    state.videoControllers = [];
    var videoReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var PREVIEW_SECONDS = 3;

    function resetOtherVideos(except) {
      for (var v = 0; v < state.videoControllers.length; v++) {
        if (state.videoControllers[v] !== except) state.videoControllers[v].reset();
      }
    }

    function initVideoCard(card) {
      var video = card.querySelector('.oddit-section-ugc-carousel__video');
      if (!video) return;
      var playBtn = card.querySelector('.oddit-section-ugc-carousel__play');
      var previewHandler = null;

      function clearPreviewLoop() {
        if (previewHandler) {
          video.removeEventListener('timeupdate', previewHandler);
          previewHandler = null;
        }
      }

      function reset() {
        clearPreviewLoop();
        if (!video.paused) video.pause();
        video.controls = false;
        video.muted = true;
        try { video.currentTime = 0; } catch (e) {}
        card.setAttribute('data-ugc-state', 'idle');
      }

      var controller = { reset: reset };

      function startPreview() {
        if (videoReducedMotion.matches) return;
        if (card.getAttribute('data-ugc-state') === 'playing') return;
        resetOtherVideos(controller);
        card.setAttribute('data-ugc-state', 'preview');
        video.controls = false;
        video.muted = true;
        try { video.currentTime = 0; } catch (e) {}
        clearPreviewLoop();
        previewHandler = function () {
          if (video.currentTime >= PREVIEW_SECONDS) {
            try { video.currentTime = 0; } catch (e) {}
          }
        };
        video.addEventListener('timeupdate', previewHandler);
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      }

      function stopPreview() {
        if (card.getAttribute('data-ugc-state') === 'preview') reset();
      }

      function startFull() {
        resetOtherVideos(controller);
        clearPreviewLoop();
        card.setAttribute('data-ugc-state', 'playing');
        video.muted = false;
        video.controls = true;
        try { video.currentTime = 0; } catch (e) {}
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      }

      card.addEventListener('mouseenter', startPreview);
      card.addEventListener('mouseleave', stopPreview);
      if (playBtn) {
        playBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          startFull();
        });
      }
      video.addEventListener('ended', reset);

      state.cleanup.push(function () {
        card.removeEventListener('mouseenter', startPreview);
        card.removeEventListener('mouseleave', stopPreview);
        video.removeEventListener('ended', reset);
        clearPreviewLoop();
      });

      state.videoControllers.push(controller);
    }

    for (var vi = 0; vi < originals.length; vi++) {
      if (originals[vi].hasAttribute('data-ugc-video')) initVideoCard(originals[vi]);
    }

    // ---- Initial state ----
    if (loop) setScrollInstant(state.realStart);
    state.currentIndex = 0;
    updateDots(0);

    state.autoplay = initAutoplay();
    sectionState.set(sectionKey, state);
  }

  function destroySection(section) {
    if (!section) return;
    var key = section.id;
    var state = sectionState.get(key);
    if (!state) return;
    if (state.autoplay) state.autoplay.destroy();
    for (var i = 0; i < state.cleanup.length; i++) {
      try { state.cleanup[i](); } catch (e) {}
    }
    if (state.settleTimer) clearTimeout(state.settleTimer);

    var track = section.querySelector('.oddit-section-ugc-carousel__track');
    if (track) {
      var clones = track.querySelectorAll('[' + CLONE_ATTR + ']');
      for (var c = 0; c < clones.length; c++) {
        if (clones[c].parentNode) clones[c].parentNode.removeChild(clones[c]);
      }
    }

    sectionState.delete(key);
    section.dataset.odditUgcInit = '';
  }

  function initAll(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll(SECTION_SELECTOR);
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();
